import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { bandData } from "../mock";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-black/95 backdrop-blur-md shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <button
            onClick={() => scrollToSection("hero")}
            className="flex items-center space-x-3 group"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_searching-fusion/artifacts/fho35rrj_Screenshot_20250629_143145_Facebook.png"
              alt="Searching Fusion Logo"
              className="h-12 w-12 rounded-full object-cover"
            />
            <span className="text-xl font-bold text-white group-hover:text-[#00d9ff]">
              {bandData.name}
            </span>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection("about")}
              className="text-white hover:text-[#00d9ff] font-medium"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection("members")}
              className="text-white hover:text-[#00d9ff] font-medium"
            >
              Members
            </button>
            <button
              onClick={() => scrollToSection("shows")}
              className="text-white hover:text-[#00d9ff] font-medium"
            >
              Shows
            </button>
            <button
              onClick={() => scrollToSection("booking")}
              className="bg-[#ff6b35] hover:bg-[#d1503a] text-white px-6 py-2 rounded-full font-bold"
            >
              Book Us
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white hover:text-[#00d9ff]"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden py-4 space-y-4 border-t border-white/10">
            <button
              onClick={() => scrollToSection("about")}
              className="block w-full text-left text-white hover:text-[#00d9ff] font-medium py-2"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection("members")}
              className="block w-full text-left text-white hover:text-[#00d9ff] font-medium py-2"
            >
              Members
            </button>
            <button
              onClick={() => scrollToSection("shows")}
              className="block w-full text-left text-white hover:text-[#00d9ff] font-medium py-2"
            >
              Shows
            </button>
            <button
              onClick={() => scrollToSection("booking")}
              className="w-full bg-[#ff6b35] hover:bg-[#d1503a] text-white px-6 py-2 rounded-full font-bold mt-4"
            >
              Book Us
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
